import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS, Title, Tooltip, Legend } from "chart.js/auto";
import { connect } from "react-redux";
import { AMC_DETAILS } from "../../variable";
import { motheDifference } from "../../utils/camelCase";

ChartJS.register(Title, Tooltip, Legend);

// 🔧 Added helper function to remove keys with 0 values
const filterZeroValues = (dataObj) => {
  return Object.fromEntries(
    Object.entries(dataObj || {}).filter(([_, val]) => parseFloat(val) !== 0)
  );
};

function LineGraph(props) {
  const [actualData, setActualData] = React.useState([]);
  const [filteredData, setFilteredData] = React.useState([]);
  const [allData, setAllData] = useState([]);

  let monthDifference =
    motheDifference(new Date(AMC_DETAILS.SCHEME_STARTING_MONTH), new Date()) -
    1;

  const AllTypeOfCategory =
    props?.performanceGraphData && Object.keys(props.performanceGraphData);

  useEffect(() => {
    setActualData(
      allData.filter((eachData) => {
        return eachData.label === props.fundType.name;
      })
    );
  }, [props.fundType, allData]);

  useEffect(() => {
    let actualDataindex = actualData;
    if (actualDataindex[0]) {
      let temp =
        monthDifference > 10
          ? actualData[0].data
          : actualData[0].data.slice(10 - monthDifference, 12);
      actualDataindex[0].data = temp;
      setFilteredData(actualDataindex);
    }
  }, [actualData]);

  useEffect(() => {
    let dataTotal = [];
    let genericCategory = [];
    if (props?.performanceGraphData) {
      for (let index = 0; index < AllTypeOfCategory.length; index++) {
        let specificData = [];

        // 🔧 Filter out 0 values before collecting data
        Object.values(
          filterZeroValues(
            props?.performanceGraphData[`${AllTypeOfCategory[index]}`]
          )
        ).forEach((key) => {
          specificData.push(key);
        });

        genericCategory.push({
          label: AllTypeOfCategory[index],
          data: specificData,
          borderColor: props.fundType.color,
          backgroundColor: props.fundType.color,
          tension: 0.4,
        });
      }

      // 🔧 Filter TotalPerformanceData too
      Object.values(
        filterZeroValues(props.performanceGraphData["TotalPerformanceData"])
      ).forEach((key) => {
        dataTotal.push(key);
      });

      genericCategory.push({
        label: "Total",
        data: dataTotal,
        borderColor: props.fundType.color,
        backgroundColor: props.fundType.color,
        tension: 0.4,
      });

      setAllData(genericCategory);
    }
  }, [props?.performanceGraphData, props.fundType.color]);

  const chartData = {
    labels:
      monthDifference > 10
        ? Object.keys(
            filterZeroValues(
              props?.performanceGraphData?.["TotalPerformanceData"]
            ) // 🔧
          )
        : Object.keys(
            filterZeroValues(
              props?.performanceGraphData?.["TotalPerformanceData"]
            ) // 🔧
          ).slice(10 - monthDifference, 12),
    datasets: actualData.length > 0 ? filteredData : [],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: false,
      },
      legend: {
        display: false,
      },
      tooltip: {
        mode: "index",
        intersect: true,
        borderWidth: 1,
        callbacks: {
          label: function (context) {
            const label = context.dataset.label || "";
            const cleanNumber = context.formattedValue.replace(/,/g, "");
            const a = parseFloat(cleanNumber);
            const b = (a / 1e6).toFixed(2);
            const value = b;
            return `${label}: ${value}M`;
          },
        },
      },
    },
    scales: {
      x: {
        display: true,
        title: {
          display: true,
        },
        ticks: {
          stepSize: 0,
          maxRotation: 90,
          minRotation: 90,
        },
        grid: {
          display: false,
        },
      },
      y: {
        display: true,
        min: 0,
        grid: {
          drawTicks: false,
          drawBorder: true,
        },
        title: {
          display: true,
        },
        ticks: {
          callback: function (value) {
            return formatNumber(value);
          },
        },
      },
    },
    layout: {
      padding: {
        top: 0,
        right: 0,
        bottom: 10,
        left: -10,
      },
    },
  };

  return <Line data={chartData} options={options} height={200} />;
}

function formatNumber(value) {
  if (value >= 1000000) {
    return (value / 1000000).toFixed(0) + "M";
  } else {
    return value.toFixed(0);
  }
}

const mapStatetoProps = (state) => {
  return {
    fundType: state.mainReducer.fundType,
  };
};

export default connect(mapStatetoProps)(LineGraph);
